<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body [centered]="true">
    <ng-container *ngIf="installationsStore.loaded$ | async; else loader" main>
      <mat-horizontal-stepper #stepper [selectedIndex]="currentStep">
        <mat-step #first_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.SELECT_PLAN' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === null || stepper.selected === first_step">
            <app-flat-booking-plans
              (planSelected)="nextStep(stepper)"
              (trialPlanSelected)="initTrialStep(stepper)"
              data-at-booking-overlay
            >
            </app-flat-booking-plans>
          </ng-container>
        </mat-step>

        <mat-step #trial_step *ngIf="selectedPlan === subscriptionPlan.Trial">
          <ng-template matStepLabel>{{
            '+BOOKING.STEPPER.SELECT_DEVICES' | translate
          }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === trial_step">
            <button
              class="btn-back"
              mat-button
              mat-raised-button
              gtm="onSelect"
              gtmAction="Booking Stepper"
              gtmCategory="booking"
              color="primary"
              (click)="resetSelectedPlan()"
              data-at-back-button
            >
              {{ 'GENERAL.BUTTON.BACK' | translate }}
            </button>
            <app-booking-devices
              (nextPage)="nextStep(stepper); createTrialSubscription()"
            ></app-booking-devices>
          </ng-container>
        </mat-step>

        <mat-step #checkout_step>
          <ng-template matStepLabel>{{ '+BOOKING.STEPPER.CHECKOUT' | translate }}</ng-template>
          <ng-template matStepperIcon="edit">
            <mat-icon>check</mat-icon>
          </ng-template>

          <ng-container *ngIf="stepper.selected === checkout_step">
            <app-flat-booking-checkout
              (reset)="initialStep(stepper)"
              (back)="previousStep(stepper)"
            >
            </app-flat-booking-checkout>
          </ng-container>
        </mat-step>
      </mat-horizontal-stepper>
    </ng-container>
  </vi-content>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>

<ng-template #loader>
  <vi-loader main data-at-loader [isLoading]="true"></vi-loader>
</ng-template>
